<template>
    <div class="detailview">    
        <div v-if="this.$parent.logintoken && !triggeredPost">{{ getPost() }}</div>    
        <div v-if="!post.id">
            <div v-if="nodata">
                Beitrag nicht gefunden.
            </div>
            <div v-else>
                Lade Beitrag...
                <font-awesome-icon icon="spinner" spin/>
            </div>
        </div>
        <div v-if="post.id">
            <div class="detailpost">
                <h4>{{post.title}}</h4>
                <h2 v-html="post.meta_titel2"></h2>
                <div v-if="post.meta_ausgabe && post.meta_ausgabejahr" class="ausgabe">
                    Ausgabe {{ post.meta_ausgabe }} / {{ post.meta_ausgabejahr }}<span v-if="post.meta_erscheinungsdatum">,&nbsp;{{formatDate(post.meta_erscheinungsdatum)}}</span>
                </div>
                <div v-if="post.hasaccess">
                    <div v-for="(paragraph, index) in post.content" :key="paragraph.id">
                        <!--current par = {{ index }}-->
                        <div v-if="index==2">
                            <div id='advertise-text' v-if='advertise && advertise.text && advertise.text[post.opus[0]] && $ms.hasElements(advertise.text[post.opus[0]]) && post.hasaccess && post.show_ads == 1'>
                                <Adslider id='adslider-text' :ads='advertise.text[post.opus[0]]' :speed='parseInt(advertise.text[post.opus[0]][0].speed) || 10' :postId='parseInt(post.id)'></Adslider>
                            </div> 
                        </div>                        
                        <div v-if="index==$leseapp.detail_picindex">
                            <div v-if="$ms.isOnline() && post['pic_attachment_id'] && post['attachments']">
                                <div v-for="attachment in post['attachments']" :key="attachment.id">
                                    <p v-if="(attachment.id == post['pic_attachment_id']) && (attachment['mime_type'].substr(0,6) == 'image/') && attachment.url">
                                        <img class='img-headline' v-bind:src="attachment.url" />
                                        <span class='img-text' v-if="post['meta_bildunterschrift']">
                                            {{ post['meta_bildunterschrift'] }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                        </div>                        
                        <p v-html="paragraph"></p>
                    </div>
                    <div v-if="post.content.length < $leseapp.detail_picindex">
                        <div v-if="$ms.isOnline() && post['pic_attachment_id'] && post['attachments']">
                            <div v-for="attachment in post['attachments']" :key="attachment.id">
                                <p v-if="(attachment.id == post['pic_attachment_id']) && (attachment['mime_type'].substr(0,6) == 'image/') && attachment.url">
                                    <img class='img-headline' v-bind:src="attachment.url" />
                                    <span class='img-text' v-if="post['meta_bildunterschrift']">
                                        {{ post['meta_bildunterschrift'] }}
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>                        
                </div>
                <p v-if="!post.hasaccess" v-html="post.excerpt"></p>
                <p v-if="!post.hasaccess">                    
                    <a :href='subscribe_url'>
                        Bitte schließen Sie hier ein Abonnement ab, um weiterzulesen!                        
                    </a>
                </p>                
            </div>
            <div id='advertise-stopper' v-if='advertise && advertise.stopper && advertise.stopper[post.opus[0]] && $ms.hasElements(advertise.stopper[post.opus[0]]) && post.show_ads == 1'>                
                <Adslider id='adslider-stopper' :ads='advertise.stopper[post.opus[0]]' :speed='parseInt(advertise.stopper[post.opus[0]][0].speed) || 10' :postId='parseInt(post.id)'></Adslider>
            </div> 
        </div>
    </div>
</template>
<script>
import Adslider from './Adslider.vue'
import MS_CONST from '../msclasses/msconst.js'

export default {
    name: 'Detailview',
    components: {
        Adslider,
    },
    props: {
    },
    data() {
        return {
            listitem: String,
            postid: String,
            post: {},
            advertise: {},
            nodata: false,
            triggeredPost: false,
            subscribe_url: MS_CONST.SUBSCRIBE_URL
        }        
    },
    created() {
        this.listitem = this.$parent.$route.params.subid;
        this.postid = this.$parent.$route.params.postid;
        this.buildTopiclist();        
        this.getAdvertising();        
        if (this.$route.name == 'ForwardDetailview')
            this.$parent.setBacklink('/top');
        else if (this.$parent.$route.params.subid)
            this.$parent.setBacklink('/top/' + this.$parent.$route.params.topid +  '/sub/' + this.$parent.$route.params.subid + '/jump/' + this.$parent.$route.params.postid);
        else
            this.$parent.setBacklink('/top/' + this.$parent.$route.params.topid + '/jump/' + this.$parent.$route.params.postid);
    },
    mounted() {
        require('../assets/css/Detailview.css')
        try { require('../assets/css/' + this.$mode + '/Detailview.css') } catch (e) {}
    },
    methods: {
        buildTopiclist() {
            var self = this;
            this.$ms.loadCacheLogin(function(login) {                
                    if (login && login.topiclist) { 
                        self.$parent.topicheaders = [];                         
                        login.topiclist.forEach(function(item) {
                            item.subtopiclist.forEach(function(subitem) {
                                self.$parent.topicheaders[subitem.list_id] = subitem.list_label;
                            });
                            self.$parent.topicheaders[item.list_id] = item.list_label;
                        });
                    }
                    else    
                        self.$log.debug('Keine Topicliste');
            });
        },
        getAdvertising() {
            var self = this;
            this.$ms.loadCacheAdvertise(function(cache) {
                if (cache) {
                    self.$log.debug('advertise read from cache');    
                    self.advertise = cache;
                } 
            });
        },
        getPost() {
            // Cache-Strategie: "Wenn online, Netzwerk, sonst Cache"
            // Ist der User online, wird die Netzwerk-Version geladen und angezeigt.
            // Die geladene Version wird in den Cache gespeichert.
            // Ist der User offline, wird falls vorhanden die Cache-Version angezeigt
            var self = this;
            self.triggeredPost = true;
            self.nodata = false;
                if (self.$ms.isOnline()){
                    self.$ms.apiPost(self, self.$parent.logintoken, self.$parent.$route.params.topid, self.postid, function(err, data) {
                        if (!err) {                            
                            self.$log.debug('post read from web');    
                            if (data.id)
                                self.post = data;
                            else
                                self.nodata = true;
                            // In den Cache speichern
                            self.$log.debug('post from web saved to cache');    
                            self.$ms.saveCacheContentPost(self.$parent.$route.params.topid, self.postid, data);
                        }
                        else {
                            self.$log.warn('msAxios meldet: ' + error);
                            self.$ms.showError(self, 'Die gewünschte Ressource konnte nicht geladen werden.');
                            self.nodata = true;
                        }
                    });
                } else {
                    this.$ms.loadCacheContentPost(self.$parent.$route.params.topid, self.postid, function(cache) {
                        self.$log.debug('getPost response');
                        var cacheFound = (cache && cache.id);
                        if (cacheFound) {
                            self.$log.debug('post read from cache');    
                            self.post = cache;
                        } 
                        if (!cacheFound && !self.$ms.isOnline()) {
                            self.$ms.showError(self, 'Die gewünschte Ressource konnte nicht geladen werden. Bitte verbinden Sie sich mit dem Internet und versuchen es erneut.');
                            self.nodata = true;
                        }
                    });
                }
        },
        formatDate(date) {
            // Eingabeformat: yyyymmdd, Ausgabeformat: dd.mm.yyyy
            let d = date.substr(6,2);
            let m = date.substr(4,2);
            let y = date.substr(0,4);
            return d + "." + m + "." + y;
        }

    }
}
</script>

<style />